import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "processd" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"40px"} }, null, -1)
const _hoisted_3 = {
  class: "flex-end",
  style: {"margin":"30px 40px"}
}
const _hoisted_4 = ["src"]

import { t } from '@/plugins/i18n'
import {
  regularizationInvalid,
  regularizationRegular
} from '@/apis/stock'


import TableButton from '@/components/Table/TableButton.vue'
import { ElMessage } from 'element-plus'
import { defineComponent, defineProps, defineEmits, reactive, ref, computed, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible', 'submit'],
  setup(__props, { emit: emits }) {

const props = __props



const closeImg = ref()
closeImg.value = require('@/assets/image/icon/close.svg')
const submit = function () {
  emits('submit')
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      "model-value": __props.visible,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (emits('update:visible', false))),
      "show-close": false
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _renderSlot(_ctx.$slots, "adtList"),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submit,
            style: {"margin-left":"10px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('确认并支付')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("img", {
          src: closeImg.value,
          alt: "",
          class: "closeImg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('update:visible', false)))
        }, null, 8, _hoisted_4)
      ]),
      _: 3
    }, 8, ["model-value"])
  ]))
}
}

})